import React from "react";
import "./Magazines.css";
import { useNavigate } from "react-router-dom";
import { Datacontext } from "../context/Datacontext";
import { useContext } from "react";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";

const Magazines = () => {
    const { magazines, loading, refetch } = useContext(Datacontext);
    const navigate = useNavigate()

    // Fetch magazines on mount
    useEffect(() => {
        if (refetch) refetch();
    }, [refetch]);

    const handleView = async (id) => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        fetch(`${backendUrl}/api/magazines/${id}/view`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            // Optional: Add auth if only logged-in users should count downloads
            // credentials: "include",
        }).catch((err) => {
            console.warn("Failed to track download count:", err);
            // Don't show error to user – download can still proceed
        });
        navigate(`/reader/${id}`)

    }
    // ✅ DOWNLOAD HANDLER
    const handleDownload = async (mag) => {
  try {
    if (!mag.pdf_file || !mag.id) {
      toast.error("PDF not available or invalid magazine");
      return;
    }

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const fileUrl = `${backendUrl}${mag.pdf_file}`;

    // Track download (fire-and-forget)
    fetch(`${backendUrl}/api/magazines/${mag.id}/download`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }).catch(() => {});

    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to fetch PDF`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${mag.title.replace(/[^a-z0-9]/gi, "_")}.pdf`;

    document.body.appendChild(link);
    link.click();

    // ✅ ONLY revoke object URL (safe)
    window.URL.revokeObjectURL(url);

    toast.success("Downloaded successfully!");
  } catch (error) {
    console.error("Download error:", error);
    toast.error("Failed to download the magazine");
  }
};

  // 🔄 LOADER
  if (loading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
        <Spinner animation="border" variant="primary" style={{ width: "2rem", height: "2rem" }} />
        <h5 className="mt-4 text-muted">Loading magazines...</h5>
      </div>
    );
  }

   return (
  magazines.length === 0 ? (
    <p className="empty-msg">No magazines available</p>
  ) : (
    <div className="magazine-page">
      <div className="magazines-container">
        <div className="magazines-header">
          <h1 className="page-title">Magazines</h1>
          <p className="subtitle">
            Read your favourite author’s latest publications
          </p>
        </div>

        <div className="magazines-grid">
         {magazines
  .filter((mag) => mag.is_published === 1)
  .map((mag) => (

            <div className="mag-card" key={mag.id}>
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}${mag.cover_image}`}
                alt={mag.title}
                className="mag-thumb"
              />

              <div className="mag-info">
                <h2>{mag.title}</h2>
                <p className="desc">{mag.description}</p>

                <div className="btn-row">
                  <button
                    className="read-btn"
                    onClick={() => handleView(mag.id)}
                  >
                    Read Online
                  </button>

                  <button
                    className="download-btn"
                    onClick={() => handleDownload(mag)}
                  >
                    Download
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
);

}


export default Magazines;